import { useEffect, useMemo, useState } from 'react';
import { get } from 'lodash';

import { ACL, UserCan } from '../../../shared/constants';
import { getAllDevicesTag, handleSearch } from '../../../shared/helpers';
import { UserAuth, iList, iTagInfoBase } from '../../../shared/interfaces';

interface UseTagsFilterParams<TExtra = unknown> {
  items: iList<iTagInfoBase<TExtra>>;
  authUser: UserAuth;
  userCanDo: string[];
  devicesIds: string[];
}

export const useTagsFilter = <TExtra = unknown>({
  items,
  authUser,
  userCanDo,
  devicesIds,
}: UseTagsFilterParams<TExtra>) => {
  const [searchParam] = useState(['name']);
  const [searchQueryValue, setSearchQueryValue] = useState('');
  const [tagsActualState, setTagsActualState] = useState({});

  const filteredTags = useMemo(
    () =>
      Object.keys(items).reduce((acc, rec) => {
        if (get(items[rec], `instances.allowed-see.person.${authUser.uid}`)) {
          return { ...acc, [rec]: items[rec] };
        }

        return acc;
      }, {}),
    [items, authUser.uid],
  );

  const getFilters = () => {
    return ACL.check(UserCan.DO_ANYTHING, userCanDo) ||
      ACL.check(UserCan.SUB_USER, userCanDo)
      ? items
      : filteredTags;
  };

  const newItems = useMemo(
    () => ({ ...getFilters(), ...getAllDevicesTag(devicesIds) }),

    [devicesIds, filteredTags, items, userCanDo],
  );

  useEffect(() => {
    setTagsActualState(handleSearch(newItems, searchParam, searchQueryValue));
  }, [newItems, searchParam, searchQueryValue]);

  return {
    searchQueryValue,
    setSearchQueryValue,
    tagsActualState,
  };
};